/* eslint-disable */
import React from 'react';
import {
 ColDef,
 IDateFilterParams,
 ITextFilterParams,
} from '@ag-grid-community/core';
import CellRenderClipboard from '../../Shared/DataGrid/CellRenderClipboard';
import StoryPaymentDocumentCellRender from '../../Shared/DataGrid/StoryPaymentDocumentCellRender';

const StoryPaymentColumns = () => {
 const columns: ColDef[] = [];

 let column: ColDef = {
  field: 'recordNumber',
  headerName: '№',
  minWidth: 200,
  maxWidth: 200,
  filter: false,
  sortable: false,
  pinned: 'left',
  suppressFiltersToolPanel: true,
  suppressMenu: true,
  resizable: false,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
 };
 columns.push(column);

 column = {
  field: 'documetDate',
  headerName: 'Дата документа',
  minWidth: 200,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
  filter: 'agDateColumnFilter',
  filterParams: {
   comparator: (filterLocalDateAtMidnight, cellValue) => {
    if (cellValue == null) {
     return 0;
    }

    const dateParts = cellValue.split('.');
    const year = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const day = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
     return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
     return 1;
    }
    return 0;
   },

   buttons: ['apply', 'reset'],
   closeOnApply: true,
   inRangeFloatingFilterDateFormat: 'YYYY-MM-DD',
   inRangeInclusive: true,
  } as IDateFilterParams,
  cellRenderer: CellRenderClipboard,
  lockVisible: false,
 };
 columns.push(column);

 column = {
  field: 'documentNumber',
  headerName: 'Номер документа',
  minWidth: 200,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };

 columns.push(column);

 column = {
  field: 'paymentAmount',
  headerName: 'Сумма платежа, ₽',
  minWidth: 200,
  maxWidth: 200,
  cellClass: 'ag-left-aligned-cell',
  cellRenderer: CellRenderClipboard,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'right',
  }),
  valueFormatter: function (params) {
   return params?.data?.paymentAmount
    ? params.data.paymentAmount.toLocaleString('ru-RU')
    : null;
  },
  filter: 'agNumberColumnFilter',
 };
 columns.push(column);

 column = {
  field: 'status',
  headerName: 'Статус',
  minWidth: 200,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 column = {
  field: 'paymentType',
  headerName: 'Источник платежа',
  minWidth: 200,
  maxWidth: 200,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 column = {
  field: 'paymentType',
  headerName: 'Детали о платеже',
  minWidth: 400,
  maxWidth: 400,
  filter: false,
  sortable: false,
  suppressFiltersToolPanel: true,
  suppressMenu: true,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
  lockVisible: false,
  cellRenderer: StoryPaymentDocumentCellRender,
 };
 columns.push(column);

 return { columns };
};

export { StoryPaymentColumns };
